module.exports = __webpack_public_path__ + "img/close-small.2a9a0f86.svg";